// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import NavManagementPage from './pages/NavManagement';
// import SigninPage from './pages/Signin';
// import { NotificationContainer } from 'react-notifications';
// import 'react-notifications/lib/notifications.css';

// const App = () => {
//   return (
//     <div>
//     <NotificationContainer />
   
//     <Router>
//       <Routes>
//         <Route path="/" element={<NavManagementPage />} />
//         <Route path="/login" element = {<SigninPage />} />
//       </Routes>
//     </Router>
//     </div>
//   );
// };

// export default App;
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavManagementPage from './pages/NavManagement';
import IndUserPage from './pages/IndividualClients';
import SigninPage from './pages/Signin';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './App.css'; // Add your custom styles here
import logo from './assets/logo2.png'; // Import the logo
import CorUserPage from './pages/CorporateClients';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Simulate a 1-second loading delay

    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <img 
          src={logo} 
          alt="Loading..." 
          className="loading-logo" 
        />
        <div className="loading-spinner"></div> {/* Spinner below the logo */}
      </div>
    );
  }

  return (
    <div>
      <NotificationContainer />
      <Router>
        <Routes>
          <Route path="/" element={<NavManagementPage />} />
          <Route path="/login" element={<SigninPage />} />
          <Route path='/ind-client' element ={<IndUserPage/>} />
          <Route path='/cor-client' element ={<CorUserPage/>} />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
